













































import Modal from '@/components/Modal/Modal.vue'
import ModalContent from '@/components/Modal/ModalContent.vue'
import ModalHeader from '@/components/Modal/ModalHeader.vue'
import ModalFooter from '@/components/Modal/ModalFooter.vue'
import StageNav from '@/components/AddTest/StageNav.vue'
import AjaxButton from '@/components/AjaxButton.vue'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import store from '@/store'
import { Button } from '@alpha/ink'
import { TemplateSubmissionPayload } from '@/utilities/template-helpers'
import { Location } from '@/components/Templates/TemplateManager.vue'
import TemplateBuilder from '@/components/AddTest/TemplateBuilder.vue'
import * as db from '@shared/types/database'
import ConfirmExitPopup from '@/components/TestDetails/DefaultTestCreation/ConfirmExitPopup.vue'
import api from '@/api'
import Overlay from '@/components/Overlay.vue'
import { SelectedTemplate } from '@/types/frontend'

@Component({
  components: {
    ConfirmExitPopup,
    TemplateBuilder,
    Modal,
    StageNav,
    AjaxButton,
    ModalContent,
    ModalHeader,
    ModalFooter,
    Overlay,
    Button
  }
})
export default class TemplateTestContentModal extends Vue {
  @Prop({ required: true }) test!: db.Test
  @Prop({ required: true }) testId!: string
  @Prop({ required: true }) workspaceId!: string
  @Prop({ required: true }) projectId!: string
  @Prop({ required: true }) readonly initialTemplate!: SelectedTemplate

  @Ref('templateBuilder') readonly templateBuilderComponent!: TemplateBuilder

  loading = false
  cancelAlert = false

  templateSubmissionPayload: TemplateSubmissionPayload | null = null
  location = Location.TemplateTestModal

  updateTemplate (templateUpdates: Pick<TemplateSubmissionPayload, 'renderedTemplate' | 'templateFieldValues'>) {
    this.templateSubmissionPayload = templateUpdates
  }

  get saveDisabled () {
    return this.loading ||
        (!this.templateSubmissionPayload?.testTemplateId && !this.templateSubmissionPayload?.saveNewTemplate)
  }

  get templateHasChanged () {
    if (!this.templateSubmissionPayload) return false
    return this.initialTemplate?.template.id !== this.templateSubmissionPayload?.testTemplateId
  }

  get templateValuesHaveChanged () {
    if (!this.templateSubmissionPayload) return false
    return JSON.stringify(this.initialTemplate?.templateValues) !== JSON.stringify(this.templateSubmissionPayload?.templateFieldValues)
  }

  triggerCancelAlert () {
    if (this.templateHasChanged || this.templateValuesHaveChanged) {
      this.cancelAlert = true
    } else {
      this.close()
    }
  }

  async save () {
    this.loading = true
    const isTemplateValid = this.templateBuilderComponent.submit()
    store.dispatch.testCreation.setTestValidForSubmission(isTemplateValid)

    const { saveNewTemplate, newTemplatePayload, ...templateSubmission } = this.templateSubmissionPayload!

    // Custom template case
    if (saveNewTemplate) {
      const result = await api.createTemplate(this.workspaceId, newTemplatePayload)
      templateSubmission.testTemplateId = result.data
    }

    await store.dispatch.workspace.updateTest({
      testId: this.testId,
      workspaceId: this.workspaceId,
      test: {
        // Add in template values
        ...templateSubmission,
        testType: 'Template',
        prototypes: store.state.testCreation.prototypes ?? {}
      }
    })

    this.loading = false
    this.$emit('save', templateSubmission)
  }

  close () {
    this.$emit('close')
  }
}
